


















































import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
const Debtors = namespace("DebtorsModule");
import Paginate from "@/components/Paginate.vue";
import { BOverlay } from "bootstrap-vue";

@Component({
  name: "Debtor",
  components: {
    Paginate,
    BOverlay,
  },
})
export default class Debtor extends Vue {
  private filter = {
    Name: "",
    Number: 0,
    sort: "desc",
    index: "NameSort",
  };
  private debtors = [];
  private debtorName = "";
  private debtorNumber = "";
  private loading = true;

  private dataPagination = {
    perPage: 0,
    totalRow: 0,
    currentPage: 0,
    limit: 0,
  };

  pageChange(params: any) {
    this.getItemPerPage({
      page: params.currentPage,
      filter: this.filterQuery(),
    }).then(
      (response) => {
        this.debtors = response.debtorList;
        if (response.Paginate) {
          this.dataPagination = response.Paginate;
        }
      }
    );
  }

  private filterQuery() {
    const filter = this.filter;
    const filterData: any = {};

    if (this.debtorName !== undefined) {
      this.filter.Name = this.debtorName;
    }
    if (this.debtorNumber !== undefined) {
      this.filter.Number = parseInt(this.debtorNumber);
    }
    //index using and sort
    if (filter.index) {
      filterData.Index = filter.index;
    }
    if (filter.sort) {
      filterData.Sort = filter.sort;
    }
    filterData.Filter = this.makeFilter();
    return filterData;
  }

  private makeFilter() {
    const filter = this.filter;
    const Filter = [];
    if (filter.Name) {
      Filter.push({
        Key: "Name",
        Operator: "contains",
        Value: this.debtorName,
      });
    }
    if (filter.Number) {
      Filter.push({
        Key: "Debtor",
        Value: parseInt(this.debtorNumber),
      });
    }
    return Filter;
  }
  // ---- End Handling Paginate ----

  public clickDebtorDetail(debtorId: any) {
    this.$router.push({
      name: "DebtorDetails",
      params: { debtorId: debtorId },
    });
  }
  clickDebtorAdd() {
    this.$router.push({ name: "DebtorAdd" });
  }
  onSearch() {
    this.loading = true;
    this.retrieveDebtors(this.filterQuery()).then(
      (response) => {
        this.dataPagination = response.Paginate;
        this.debtors = response.debtorList;
        this.loading = false;
      }
    );
  }

  created() {
    this.onSearch();
  }
  @Debtors.State
  private debtorData!: Array<any>;

  @Debtors.Action
  public retrieveDebtors!: (params: any) => Promise<any>;

  @Debtors.Action
  public getItemPerPage!: (params: any) => Promise<any>;
}
